'use strict';

app.config(function ($stateProvider) {
  var PER_PAGE = 14;

  $stateProvider.state('instance.app.leaderboard', {
    url: '/leaderboard',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow();
      },
      leaderboard: function (flow, Leaderboard, $rootScope) {
        return Leaderboard.fetch($rootScope.instance._id, { limit: PER_PAGE });
      },
      chart: function (flow, $http) {
        return $http.get('/api/v1/me/chart/weeklyProgress')
          .then(_.property('data'));
      },
      userRank: function (flow, Leaderboard, $rootScope) {
        return Leaderboard.userRank($rootScope.instance._id, $rootScope.user._id).catch(_.constant(null));
      },
      achievements: function (flow, $http) {
        return $http.get('/api/v1/me/achievements')
          .then(_.property('data'));
      }
    },
    templateUrl: '/app/states/leaderboard/leaderboard.html',
    controller: function ($scope, leaderboard, userRank, achievements, chart, Leaderboard, HistoryAction, $viewport) {
      $scope.graph = {
        labels: _.map(chart, function (data) { return data.label.toUpperCase(); }),
        series: [_.pluck(chart, 'points')]
      };
      var chartPadding = $viewport.isMobile ? 20 : 50;
      $scope.graphOptions = {
        axisY: { showLabel: false, showGrid: false, offset: 0 },
        chartPadding: { top: chartPadding, right: chartPadding, bottom: 20, left: chartPadding },
        fullWidth: true,
        axisX: { offset: 30, labelOffset: { x: $viewport.isMobile ? -8 : -16, y: 20}, showGrid: false }
      };
      $scope.increaseThisWeek = _.sum(chart, 'points');
      $scope.tooltips = _.map(chart, function (data) {
        data.history.forEach(HistoryAction.format);
        return {
          label: data.weekday,
          history: data.history
        };
      });
      achievements.modulesCompleted = _.chunk(achievements.modulesCompleted, 2);
      $scope.achievements = achievements;
      $scope.expanded = false;
      var injectCurrentUser = function (leaderboard) {
        if (!userRank) {
          return leaderboard;
        }
        if (!_.find(leaderboard, {user: $scope.user._id})) {
          //push current user to the end of the leaderboard overview
          leaderboard[leaderboard.length - 1] = userRank;
        }
        return leaderboard;
      };
      var chunkLeaderboard = function (leaderboard) {
        if (!leaderboard.length) {
          return [];
        }
        var leaderBoardOverview = _.cloneDeep(leaderboard);
        injectCurrentUser(leaderBoardOverview);
        //mark last user, required for css styles
        _.last(leaderboard).isLast = true;
        return _.chunk(leaderBoardOverview, Math.ceil(leaderboard.length / 2));
      };
      $scope.leaderboardChunked = chunkLeaderboard(leaderboard || []);

      var loadNextPage = function () {
        Leaderboard.fetch($scope.instance._id, {
          skip: leaderboard.length,
          limit: PER_PAGE
        }).then(function (data) {
          $scope.lastPage = data.length < PER_PAGE;
          leaderboard = leaderboard.concat(data);
          $scope.leaderboardChunked = chunkLeaderboard(leaderboard);
        });
      };
      $scope.expand = function () {
        loadNextPage();
        $scope.expanded = true;
      };
      $scope.loadNextPage = loadNextPage;
    }
  });

});
